"use client";
import { useState } from "react";
import { showErrorToast } from "@stadium/services/react-toastify";

import { fetchOrderInvoice } from "api/order";

import { downloadBlobAsPDF } from "@stadium/helpers/dom";

import { INVOICE_DOWNLOAD_ERROR_TOAST_ID } from "@stadium/checkout/src/constants/order";

export const useDownloadInvoice = (number) => {
  const [loading, setLoading] = useState(false);

  const fetchFile = () => {
    setLoading(true);
    return fetchOrderInvoice(number)
      .then((downloadData) => {
        const fileName = `Invoice#${number}`;
        downloadBlobAsPDF({ data: downloadData, fileName });
      })
      .catch((err) => {
        showErrorToast({ message: err, config: { toastId: INVOICE_DOWNLOAD_ERROR_TOAST_ID } });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    loading,
    fetchFile,
  };
};
